export const THEMES = {
  FACTS: 'FACTS'
};

export const config = {
  API_URL: process.env.REACT_APP_API_URL,
  MAX_PROJECTS_PER_PAGE: process.env.REACT_APP_MAX_PROJECTS_PER_PAGE,
};
